// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__st32p","sendOtp":"AuthorizeToLogin_sendOtp__2F2Rw"};